function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Contactpersoon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "headphones-customer-support-human",
  transform: "translate(4.000000, 4.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.375,24.5 L4.3125,24.5 C1.96528981,24.5 0.0625,22.5972102 0.0625,20.25 L0.0625,16 C0.0625,13.6527898 1.96528981,11.75 4.3125,11.75 L5.375,11.75 C5.96180255,11.75 6.4375,12.2256975 6.4375,12.8125 L6.4375,23.4375 C6.4375,24.0243025 5.96180255,24.5 5.375,24.5 Z",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.6875,24.5 L26.625,24.5 C26.0381975,24.5 25.5625,24.0243025 25.5625,23.4375 L25.5625,12.8125 C25.5625,12.2256975 26.0381975,11.75 26.625,11.75 L27.6875,11.75 C30.0347102,11.75 31.9375,13.6527898 31.9375,16 L31.9375,20.25 C31.9375,22.5972102 30.0347102,24.5 27.6875,24.5 Z",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.3125,11.75 C4.3125,5.29517199 9.54517199,0.0625 16,0.0625 L16,0.0625 C19.0997177,0.0625 22.0724791,1.29385807 24.2643105,3.48568949 C26.4561419,5.67752092 27.6875,8.65028228 27.6875,11.75",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.25,29.8125 L23.4375,29.8125 C25.7847102,29.8125 27.6875,27.9097102 27.6875,25.5625 L27.6875,25.5625 L27.6875,24.5",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.125,31.9375 L16,31.9375 C14.8263949,31.9375 13.875,30.9861051 13.875,29.8125 C13.875,28.6388949 14.8263949,27.6875 16,27.6875 C16.6342633,27.6875 17.3425966,27.6875 18.125,27.6875 C19.2986051,27.6875 20.25,28.6388949 20.25,29.8125 C20.25,30.9861051 19.2986051,31.9375 18.125,31.9375 Z",
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.75,20.8761667 C14.1583512,23.0708111 17.8416488,23.0708111 20.25,20.8761667",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 11.75,
  y1: 13.1454167,
  x2: 11.75,
  y2: 15.0040833,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 20.25,
  y1: 13.1454167,
  x2: 20.25,
  y2: 15.0040833,
  id: "Path",
  stroke: "#485156"
})));
function SvgContractContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "40px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Contactpersoon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractContact);
export default __webpack_public_path__ + "static/media/Contract_contact.26ce9bb92e1b87fee9f7cff4296d3488.svg";
export { ForwardRef as ReactComponent };